import pickBy from 'lodash/pickBy'
import isNil from 'lodash/isNil'
import { useCallback, useEffect, useMemo } from 'react'

import { useFetch } from 'civic-champs-shared/api/hooks'
import format from 'civic-champs-shared/utils/format'
import { useCurrentOrg } from 'auth/hooks'
import { useDateRangeFilter } from '../../filtering/hooks'

export const useGetMessages = () => {
  const [request, { result, loading, called, error }] = useFetch('Error fetching Non-Custom Messages')
  const organization = useCurrentOrg()
  const [{ startDate, endDate }] = useDateRangeFilter()
  const getMessages = useCallback(async () => {
    const queryStringParameters = pickBy(
      {
        startDate: format.dateForUrl(startDate),
        endDate: format.dateForUrl(endDate),
        forGrid: true,
        isCustom: false,
      },
      value => !isNil(value),
    )

    return request({
      method: 'get',
      url: `/organizations/${organization.id}/messages`,
      config: {
        queryStringParameters,
      },
    })
  }, [organization.id, request, startDate, endDate])

  useEffect(() => {
    getMessages()
  }, [getMessages])

  return useMemo(
    () => ({ result: result || [], loading: loading || !called, called, error }),
    [result, loading, called, error],
  )
}

export default useGetMessages
